import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiWidgetTitle from 'components/MuiExtras/MuiWidgetTitle';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import PublicationRelations from 'views/Publication/Components/PublicationRelations';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    publicationId: string;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const WidgetRelations: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    return (
        <>
            <MuiContainer margin="dense">
                <MuiWidgetTitle title={t("Views.Publication.Widgets.WidgetRelations.BoxTitle")} />
                <PublicationRelations {...props} />
            </MuiContainer>
            <br />
        </>
    );
};

export default WidgetRelations;
